import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { hexToRGBA } from "@utils/hex-to-rgba";


const initialState: IThemePalette = {
    mode: 'light',
    lightPalette: {
        mode: 'light',
        primary: {
            main: '#C778DD',
            light: '#d79fe7',
            dark: "#572aa5",
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: '#ABB2BF',
            light: '#cbd1da',
            dark: '#1d232d',
            contrastText: '#FFFFFF',
        },
        background: {
            default: '#e3f2fd',
            paper: '#FFFFFF',
        },
        divider: '#ABB2BF',
        text: {
            primary: '#000000',
            secondary: hexToRGBA('#000000', 0.8),
            disabled: '#FFFFFF',
        },
    },
    darkPalette: {
        mode: 'dark',
        primary: {
            main: '#C778DD',
            light: '#d79fe7',
            dark: "#572aa5",
            contrastText: '#FFFFFF',

        },
        secondary: {
            main: '#ABB2BF',
            light: '#cbd1da',
            dark: '#1d232d',
            contrastText: '#FFFFFF',
        },
        background: {
            default: '#282C33',
            paper: '#ABB2BF',
        },
        divider: '#ABB2BF',
        text: {
            primary: '#FFFFFF',
            secondary: '#ABB2BF',
            disabled: '#000000',
        },
    }
}
const colorPaletteSlice = createSlice({
    name: "colorPalette",
    initialState,
    reducers: {
        setPrimaryColor: (state, action: PayloadAction<{ mode: 'light' | 'dark'; color: ColorType }>) => {
            if (action.payload.mode === 'light') {
                state.lightPalette.primary = action.payload.color;
            } else {
                state.darkPalette.primary = action.payload.color;
            }
        },
        setSecondaryColor: (state, action: PayloadAction<{ mode: 'light' | 'dark'; color: ColorType }>) => {
            if (action.payload.mode === 'light') {
                state.lightPalette.secondary = action.payload.color;
            } else {
                state.darkPalette.secondary = action.payload.color;
            }
        },
        setTextColor: (state, action: PayloadAction<{ mode: 'light' | 'dark'; color: TextType }>) => {
            if (action.payload.mode === 'light') {
                state.lightPalette.text = action.payload.color;
            } else {
                state.darkPalette.text = action.payload.color;
            }
        },
        setDividerColor: (state, action: PayloadAction<{ mode: 'light' | 'dark'; color: string }>) => {
            if (action.payload.mode === 'light') {
                state.lightPalette.divider = action.payload.color;
            } else {
                state.darkPalette.divider = action.payload.color;
            }
        },
        setMode: (state, action: PayloadAction<'light' | 'dark'>) => {
            state.mode = action.payload;
        },
        setDefaultBackgroundColor: (state, action: PayloadAction<{ mode: 'light' | 'dark'; color: string }>) => {
            if (action.payload.mode === 'light') {
                state.lightPalette.background.default = action.payload.color;
            } else {
                state.darkPalette.background.default = action.payload.color;
            }
        },
        setPaperBackgroundColor: (state, action: PayloadAction<{ mode: 'light' | 'dark'; color: string }>) => {
            if (action.payload.mode === 'light') {
                state.lightPalette.background.paper = action.payload.color;
            } else {
                state.darkPalette.background.paper = action.payload.color;
            }
        },
    },
});
export default colorPaletteSlice.reducer;
export const {
    setDefaultBackgroundColor,
    setDividerColor,
    setMode,
    setPaperBackgroundColor,
    setPrimaryColor,
    setSecondaryColor,
    setTextColor
} = colorPaletteSlice.actions;

